import moment from 'moment'

// eslint-disable-next-line import/prefer-default-export
export function convertToDuration(duration) {
  if (moment.isDuration(duration)) {
    return duration
  }

  return moment.duration(duration.diff())
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Time/util.js